import { t } from 'i18next';
import { parameterService } from '@/projects/syncflow/services/parameter-service';
import DataGridWrapper from '@/projects/syncflow/components/data-grid-wrapper';
import { Button, DataGrid, Popup } from 'devextreme-react';
import ParameterP001Detail from '../components/parameter/parameter_P001_detail';
import ParameterP002Detail from '../components/parameter/parameter_P002_detail';
import CustomStore from 'devextreme/data/custom_store';
import { useCallback, useEffect, useRef, useState } from 'react'

const ParameterList  = () => {

  const [popupVisible, setPopupVisible] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const [detailData, setDetailData] = useState<any[]>([]);
  const [parameterCode,setParameterCode] = useState<string>();
  const [loadingDetail, setLoadingDetail] = useState(false);  
    const dataGridRef = useRef<DataGrid>(null);
 const [paramterStore, setStore] = useState<CustomStore>();

    useEffect(() => {
        setStore(new CustomStore({
            key: ["parameterCode"],
            load: onGetOrderData,
            useDefaultSearch: true
        }));
    }, [])

    const onGetOrderData = useCallback(async () => {     
            const x = await parameterService.getParameterType();
            return x;

    }, []);

const handleShowDetail = async (data: any) => {
  setPopupVisible(true);
  setSelectedRowData(data);
  setLoadingDetail(true);
  setParameterCode(data.parameterCode);
  try {
    const response = await parameterService.getParameterDetail(data.parameterCode);
    setDetailData(response.data);
  } catch (error) {
    console.error("Detail load error:", error);
    setDetailData([]); 
  } finally {
    setLoadingDetail(false); 
  }
};
  const renderDetailContent = () => {
    if (loadingDetail) return <p>{t("loading")}...</p>;
    if (!detailData || detailData.length === 0) return <p>{t("no_data")}</p>;

    switch (selectedRowData?.parameterCode) {
      case "P001":
        return <ParameterP001Detail data={detailData} parameterCode={parameterCode}/>;
       case "P002":
         return <ParameterP002Detail data={detailData} parameterCode={parameterCode} />;
     
      default:
        return <pre>{JSON.stringify(detailData, null, 2)}</pre>;
    }
  };

  return (
      <>
       <DataGridWrapper
      props={{ ref: dataGridRef }}
      datasource={paramterStore}
      remoteOperations={false}
      columnChooser={false}
      pagerVisible={true}
      filterVisible={true}
      headerFilterVisible={true}
      keyboardNavigation={true}       
      editingConfig={{
                          mode:'batch',
                          allowUpdating: false,
                          allowEditing: false,
                      }}   
      columns={[       
        {
          dataField: "parameterCode",
          caption: t("parameter_code"),
          allowEditing: false,        
        },
        {
          dataField: "parameterName",
          caption: t("parameter_name"),  
          allowEditing: false,     
        },
        {
            caption: t('syncflow:lb_detail'),
            allowFiltering: true,
            allowEditing: false,
            cellRender: (data: any) => {
              return (
                <Button
                  text={t("syncflow:btn_detail")}
                  type="default"
                  icon='showpanel'
                  stylingMode="contained"
                  onClick={() => handleShowDetail(data.data)}
                />
              );
            },
          }
      ]}
 />
    <Popup
        visible={popupVisible}
        onHiding={() => setPopupVisible(false)}
        dragEnabled
        showCloseButton
        showTitle
        title={ selectedRowData ? selectedRowData.parameterCode + " " + selectedRowData.parameterName : t('syncflow:settings')}
        width={600}
        height={500}
      >
        <div>
          {selectedRowData && (
            <>             
              {renderDetailContent()}
            </>
          )}
        </div>
      </Popup>
    </>
  );
};
export default ParameterList;